import React, { useEffect, useState } from 'react';
import { FlatList } from 'react-native';
import styled from 'styled-components/native';
import { H5, P } from '../../components/Typography';
import Spacer from '../../components/Spacer';
import { RouteProp, useRoute } from '@react-navigation/native';
import { StudiesParamList } from '../../navigation/StudiesNavigator';
import { format } from 'date-fns';
import {
  StudyParticipantNotes,
  useGetStudyParticipantNotes
} from '../../hooks/study/useGetStudyParticipantNotes';
import ActivityIndicatorScreen from '../../components/ActivityIndicatorScreen';
import { noteDateFormat } from './NotebookListScreen';

const StyledView = styled.View`
  flex: 1;
  background-color: white;
`;

const TitleView = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin: 40px 16px 40px 16px;
`;

const StyledH5 = styled(H5)`
  font-size: 22px;
`;

const StyledNoteSubjectView = styled.View`
  height: 60px;
  background-color: #fafafa;
  justify-content: center;
  border: 1px solid #d5d5d5;
  padding: 0px 16px 0px 16px;
`;

const StyledNoteItemView = styled.View`
  width: 100%;
`;

const StyledNoteTitle = styled(H5)`
  font-family: 'WorkSans-Medium';
`;

const StyledNote = styled(P)<{ underline?: boolean }>`
  font-family: 'WorkSans-Regular';
  line-height: 26px;
  ${p => (p.underline ? 'text-decoration-line: underline;' : '')}
`;

const StyledNoteView = styled.View`
  margin: 16px 16px 24px 16px;
`;

const NotebookDetailScreen: React.FC = () => {
  const route = useRoute<RouteProp<StudiesParamList, 'StudyNotebookDetail'>>();
  const noteDate = route.params.date;
  const studyParticipantId = route?.params?.studyParticipantId;
  const {
    studyParticipantNotes,
    loadingStudyParticipantNotes,
    getStudyParticipantNotes
  } = useGetStudyParticipantNotes(studyParticipantId || 0);
  useEffect(() => {
    if (studyParticipantId) getStudyParticipantNotes();
  }, [studyParticipantId, getStudyParticipantNotes]);

  const [displayedNotes, setDisplayedNotes] =
    useState<StudyParticipantNotes[]>();
  useEffect(() => {
    setDisplayedNotes(
      studyParticipantNotes?.filter(note => {
        return (
          format(note.intendedStartDate, noteDateFormat) ===
          format(new Date(noteDate), noteDateFormat)
        );
      })
    );
  }, [noteDate, studyParticipantNotes]);
  return loadingStudyParticipantNotes ? (
    <ActivityIndicatorScreen />
  ) : (
    <StyledView>
      <TitleView>
        <StyledH5 color='dark'>
          {format(new Date(noteDate), noteDateFormat)}
        </StyledH5>
        {/* <TouchableOpacity>
          <StyledEditText color='dark'>Edit</StyledEditText>
        </TouchableOpacity> */}
      </TitleView>
      <FlatList
        data={displayedNotes}
        keyExtractor={item => item.id.toString()}
        renderItem={({ item }) => (
          <StyledNoteItemView>
            <StyledNoteSubjectView>
              <StyledNoteTitle color='dark'>{item.subject}</StyledNoteTitle>
            </StyledNoteSubjectView>
            <StyledNoteView>
              <StyledNote color='dark'>{item.note}</StyledNote>
              <Spacer size={3} />
              {/* <TouchableOpacity>
                  <StyledNote color='dark' underline>
                    Dive Deeper
                  </StyledNote>
                </TouchableOpacity> */}
            </StyledNoteView>
          </StyledNoteItemView>
        )}
      />
    </StyledView>
  );
};

export default NotebookDetailScreen;
